import { Box, styled } from '@mui/material'

const ApeironScrollBox = styled(Box)`
  --border-radius: 0px;
  --scrollbar-color: #151615;

  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: var(--border-radius);
    background-color: var(--scrollbar-color);
  }
`

export default ApeironScrollBox
